// COORDINATION > SIGN-OFF TIMELINE (owner 2026-10-29, docs SIGNOFF-SPEC S1): the page
// around the timeline - the project, the tile grid, Export snapshot and Request sign-off.
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { pickerOptions } from "./projectPicker";
import { Button, Select, Space } from "antd";
import { url, tokenRef } from "api";
import { useRememberedProject } from "helpers/projectSelection";
import CoordinationBreadcrumbs from "components/Coordination/CoordinationBreadcrumbs";
import SignoffTimeline from "./SignoffTimeline";
import "./signoff.scss";

export default function SignoffTimelinePage() {
  const { projectId: routeProjectId } = useParams();
  const history = useHistory();
  const userInfo = useSelector((st) => st.user.userInfo) || {};
  const [projects, setProjects] = useState([]);
  const [pickedId, setProjectId] = useRememberedProject(String(userInfo._id || userInfo.id || ""), projects, routeProjectId);
  const projectId = pickedId || routeProjectId;
  const [info, setInfo] = useState(null);
  const requestRef = useRef(null);
  const captureRef = useRef(null);

  useEffect(() => {
    const t = localStorage.getItem(tokenRef);
    fetch(`${url}/projects/picker`, { headers: t ? { Authorization: `Bearer ${t}` } : {} })
      .then((r) => r.json())
      .then((d) => setProjects(Array.isArray(d) ? d : d?.projects || []))
      .catch(() => setProjects([]));
  }, []);
  useEffect(() => {
    if (projectId && projectId !== routeProjectId) history.replace(`/signoff-timeline/${projectId}`);
  }, [projectId, routeProjectId, history]);
  const onLoaded = useCallback((d) => setInfo(d), []);

  const exportSnapshot = () => {
    if (!captureRef.current) return;
    const a = document.createElement("a");
    a.href = captureRef.current();
    const p = projects.find((x) => String(x._id) === String(projectId));
    a.download = `Sign-off snapshot - ${(p && p.title) || "project"} - ${new Date().toISOString().slice(0, 10)}.png`;
    a.click();
  };

  const tiles = info && info.tiles;
  return (
    <div className="signoff-page container-fluid py-3">
      <CoordinationBreadcrumbs current="Sign-off timeline" />
      <div className="signoff-page-head">
        <div>
          <h2 className="mb-0">Sign-off timeline</h2>
          <div className="signoff-muted">The model in equal tiles, coloured by owner/GC and contractor sign-off on any date. Scroll the timeline to replay it.</div>
        </div>
        <Space wrap>
          <Select showSearch optionFilterProp="label" style={{ minWidth: 200 }} placeholder="Pick a project" value={projectId || undefined}
                  onChange={setProjectId} options={pickerOptions(projects, projectId, info && info.timeline && info.timeline.projectTitle)} />
          {tiles ? <span className="signoff-grid-chip">Tiles: {tiles.grid.edgeM} m cubes · {tiles.grid.nx} × {tiles.grid.nz} × {tiles.grid.ny} grid · {(tiles.tiles || []).length.toLocaleString()} with elements</span> : null}
          <Button onClick={exportSnapshot} disabled={!tiles}>Export snapshot</Button>
          {info && info.timeline && info.timeline.canRequest ? <Button type="primary" onClick={() => requestRef.current && requestRef.current()}>Request sign-off</Button> : null}
        </Space>
      </div>
      {projectId ? (
        <SignoffTimeline key={projectId} projectId={projectId} onLoaded={onLoaded} requestRef={requestRef} captureRef={captureRef} />
      ) : <p className="signoff-muted">Pick a project.</p>}
    </div>
  );
}
